/**
 * The primary source of truth for these colors is Figma. Please don't change
 * or add values not in Figma without consulting the design team.
 *
 * @src {@link https://figma.com/design/J2hlcm5TFWuXmbu7Sqi9pA/?node-id=13-10&t=l2wqus48K5WonT8b-0}
 */
export enum Colors {
  White = 'rgb(255, 255, 255)',
  Black = 'rgb(0, 0, 0)',

  Blue1 = 'rgb(232, 244, 250)',
  Blue2 = 'rgb(209, 226, 235)',
  Blue3 = 'rgb(174, 197, 212)',
  Blue4 = 'rgb(80, 119, 150)',
  Blue5 = 'rgb(0, 48, 87)',
  Blue6 = 'rgb(0, 36, 65)',

  Ice = 'rgb(240, 246, 247)',
  Mist = 'rgb(220, 230, 235)',
  StormCloud = 'rgb(206, 216, 224)',
  Stillwater = 'rgb(152, 190, 206)',
  BlueSpruce = 'rgb(70, 108, 138)',
  Ocean = 'rgb(51, 89, 121)',

  Peach1 = 'rgb(250, 237, 232)',
  Peach2 = 'rgb(255, 219, 205)',
  Peach3 = 'rgb(245, 190, 169)',
  Peach4 = 'rgb(237, 157, 123)',
  Peach5 = 'rgb(164, 80, 20)',
  Peach6 = 'rgb(84, 59, 40)',

  Gray1 = 'rgb(250, 242, 235)',
  Gray2 = 'rgb(240, 229, 221)',
  Gray3 = 'rgb(214, 202, 191)',
  Gray4 = 'rgb(168, 154, 141)',
  Gray5 = 'rgb(105, 97, 88)',
  Gray6 = 'rgb(61, 57, 52)',

  Almond = 'rgb(250, 240, 232)',
  ToastedAlmond = 'rgb(235, 220, 209)',

  CoolGray1 = 'rgb(242, 244, 245)',
  CoolGray2 = 'rgb(230, 233, 235)',
  CoolGray3 = 'rgb(210, 214, 217)',
  CoolGray4 = 'rgb(171, 175, 178)',
  CoolGray5 = 'rgb(153, 157, 161)',
  CoolGray6 = 'rgb(126, 132, 138)',
  CoolGray7 = 'rgb(89, 96, 102)',
  CoolGray8 = 'rgb(54, 62, 69)',
  CoolGray9 = 'rgb(39, 43, 46)',

  Green1 = 'rgb(230, 242, 236)',
  Green2 = 'rgb(0, 92, 46)',

  InfoBlue1 = 'rgb(242, 247, 252)',
  InfoBlue2 = 'rgb(0, 71, 176)',

  Yellow1 = 'rgb(253, 248, 224)',
  Yellow2 = 'rgb(119, 95, 0)',

  Red1 = 'rgb(249, 230, 232)',
  Red2 = 'rgb(158, 0, 18)',
  Red3 = 'rgb(99, 7, 18)',
  Red4 = 'rgb(205, 24, 24)',

  Coral1 = 'rgb(249, 231, 232)',
  Coral2 = 'rgb(236, 87, 86)',
}
